import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from 'src/app/app.component';
import { AuthService } from 'src/app/utility/auth/auth.service';

import { SchedulerListComponent } from '../app/service/scheduler/list/list.component';
import { SchedulerDetailComponent } from '../app/service/scheduler/detail/detail.component';
import { ProjectListComponent } from '../app/service/project/list/list.component';
import { ProjectDetailComponent } from '../app/service/project/detail/detail.component';
import { ServiceCatalogLauncherComponent as ServiceCatalogLauncherComponent } from '../app/service/catalog/launcher/launcher.component';
import { ServiceAuthService } from 'src/app/utility/auth/service.auth.service';
import { ServiceCatalogListComponent } from 'src/app/service/catalog/list/list.component';
import { MindslabApiListComponent } from '@serengeti/serengeti-mindslab';


const routes: Routes = [
	{ path: 'main', component: AppComponent, canActivate: [AuthService], children: [
		{ path: 'service/scheduler/list', component: SchedulerListComponent, outlet: 'content', canActivate: [ServiceAuthService],
		data: { title: 'service.scheduler.list.title', root: true } },
		{ path: 'service/scheduler/create', component: SchedulerDetailComponent, outlet: 'content', canActivate: [ServiceAuthService],
		data: { title: 'service.scheduler.create.title' } },
		{ path: 'service/scheduler/detail/:groupId/', component: SchedulerDetailComponent, outlet: 'content', canActivate: [ServiceAuthService],
		data: { title: 'service.scheduler.detail.title' }  },
		{ path: 'service/project/list', component: ProjectListComponent, outlet: 'content', canActivate: [ServiceAuthService],
		data: { title: 'service.project.list.title', root: true } },
		{ path: 'service/project/create', component: ProjectDetailComponent, outlet: 'content', canActivate: [ServiceAuthService],
		data: { title: 'service.project.create.title' } },
		{ path: 'service/project/detail/:projectId/', component: ProjectDetailComponent, outlet: 'content', canActivate: [ServiceAuthService],
		data: { title: 'service.project.detail.title' }  },
		{ path: 'service/project/detail/:projectId/launcher', component: ServiceCatalogLauncherComponent, outlet: 'content', canActivate: [ServiceAuthService],
		data: { title: 'service.project.launcher.title' }  },
		{ path: 'service/catalog/list', component: ServiceCatalogListComponent, outlet: 'content', canActivate: [ServiceAuthService],
		data: { title: 'service.catalog.list.title', root: true } },
		{ path: 'service/catalog/launcher', component: ServiceCatalogLauncherComponent, outlet: 'content', canActivate: [ServiceAuthService],
		data: { title: 'service.catalog.launcher.title' }  },
		{ path: 'mindslab/api/list', component: MindslabApiListComponent, outlet: 'content', canActivate: [ServiceAuthService],
		data: { title: 'lib.mindslab.app-id.list.title', root: true } },
	]},
];

@NgModule({
	declarations: [],
	imports: [
		RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true }),
		CommonModule
	]
})
export class AppRoutingServiceModule { }
